export default "__VITE_ASSET__48609206__"